import React, { Component } from 'react';
import {
  Row, Col,
} from 'antd';
import autobind from 'react-autobind';
import translate from 'app/translations';

export class Completion extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    return (
      <div className="card-container responsive-border">
        <Row gutter={16}>
          <Col lg={24} xl={12}>
            <h2 className="orange-text">{this.t('Completion.subHeading')}</h2>
            <p>
              {this.t('Completion.applicationComplete')}
              <a href="mailto:appraisernetwork@solidifi.com">{this.t('Completion.emailLink')}</a>.
            </p>
          </Col>
          <Col lg={24} xl={12} className="desktop-only">
            <img
              className=""
              src="https://www.solidifi.com/wp-content/uploads/Solidifi-Extraordinary-Banner-v2.png"
              alt={this.t('Completion.womanAppraiser')}
              style={{ width: '100%', padding: '1rem 0' }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default Completion;
